import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { isKey } from "../utils.js";
import { RPCInstanceContext } from "./fields.js";
const defaultBrod = ()=>{};
const useRPC = (ops)=>{
    const { brodcastScope, mount } = useContext(RPCInstanceContext);
    const [connected, setConnected] = useState(false);
    const decoratorRef = useRef(null);
    const processRef = useRef(Promise.resolve(null));
    const destroyRef = useRef(()=>{});
    const opsRef = useRef(ops);
    const rpcIns = useMemo(()=>new Proxy({}, {
            get (_, key, ref) {
                if (decoratorRef.current && isKey(key, decoratorRef.current)) return Reflect.get(decoratorRef.current, key, ref);
                throw new Error(`outof decorator: ${key.toString()}`);
            },
            has (_, key) {
                return null !== decoratorRef.current && key in decoratorRef.current;
            },
            set () {
                throw new Error('decorator is readonly');
            }
        }), []);
    const mounHandle = useCallback((name)=>{
        if (decoratorRef.current) mount?.(decoratorRef.current, name);
    }, [
        mount
    ]);
    const start = useCallback(()=>{
        const { config, options, drive, faild, init, name = '', ...opConfig } = opsRef.current;
        setConnected(false);
        processRef.current = processRef.current.then(()=>init()).then((tar)=>{
            if (options && tar instanceof HTMLIFrameElement) options.observer = ()=>tar;
            return tar instanceof HTMLIFrameElement ? tar.contentWindow : tar;
        }).then((tar)=>{
            const context = {
                ...opConfig,
                config: {
                    ...config,
                    onConnect () {
                        config?.onConnect?.();
                        setConnected(true);
                    },
                    onDisconnect (destroy) {
                        config?.onDisconnect?.(destroy);
                        setConnected(false);
                    }
                }
            };
            return drive(tar, {
                context,
                options
            });
        }).then((target)=>{
            const [result, destroy] = target;
            decoratorRef.current = result;
            destroyRef.current = destroy;
            mount?.(result, name);
            return target;
        }).catch((error)=>{
            if (decoratorRef.current) mount?.(decoratorRef.current);
            destroyRef.current();
            faild?.(error);
            return null;
        });
        return ()=>{
            processRef.current = processRef.current.then((target)=>{
                setConnected(false);
                if (target) {
                    const [result, destroy] = target;
                    mount?.(result);
                    destroy();
                }
                decoratorRef.current = null;
                return null;
            });
        };
    }, [
        mount
    ]);
    useEffect(start, [
        start
    ]);
    return Object.freeze({
        rpc: rpcIns,
        brodcastScope: brodcastScope ?? defaultBrod,
        destroy: ()=>destroyRef.current?.(),
        mount: mounHandle,
        connected,
        start
    });
};
const hooks = useRPC;
export { hooks as default };
